import { z } from 'zod/v4';

export const BulkDeleteActionsRequestSchema = z.object({
  actionIds: z
    .array(z.string().min(1, 'Action ID is required'))
    .min(1, 'At least one action ID is required')
    .max(100, 'Maximum 100 action IDs allowed per request'),
});

export type BulkDeleteActionsRequest = z.infer<
  typeof BulkDeleteActionsRequestSchema
>;

export const BulkDeleteActionsQuerySchema = z.object({
  includeLinkedActions: z
    .union([z.boolean(), z.literal('true'), z.literal('false')])
    .optional()
    .default(false)
    .transform(val => val === true || val === 'true'),
});

export type BulkDeleteActionsQuery = z.infer<
  typeof BulkDeleteActionsQuerySchema
>;
